import * as successIcon from '@nordhealth/icons/lib/assets/interface-checked-circle.js'
import * as warningIcon from '@nordhealth/icons/lib/assets/interface-help.js'
import * as infoIcon from '@nordhealth/icons/lib/assets/interface-info.js'
import * as dangerIcon from '@nordhealth/icons/lib/assets/interface-warning.js'
import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import componentStyle from '../common/styles/Component.css'

import Icon from '../icon/Icon.js'
import style from './Banner.css'

Icon.registerIcon(warningIcon)
Icon.registerIcon(dangerIcon)
Icon.registerIcon(infoIcon)
Icon.registerIcon(successIcon)

const iconMap: Record<Banner['variant'], string> = {
  warning: warningIcon.title,
  danger: dangerIcon.title,
  info: infoIcon.title,
  success: successIcon.title,
}

/**
 * Banner informs users about important changes or conditions in the
 * interface. Use this component if you need to communicate to users
 * in a prominent way.
 *
 * @status ready
 * @category feedback
 * @slot - default slot
 *
 * @cssprop [--n-banner-border-radius=var(--n-border-radius)] - Controls how rounded the corners are, using [border radius tokens](/tokens/#border-radius).
 * @cssprop [--n-banner-box-shadow=var(--n-box-shadow-card)] - Controls the surrounding shadow, using [box shadow tokens](/tokens/#box-shadow).
 */
@customElement('nord-banner')
export default class Banner extends LitElement {
  static styles = [componentStyle, style]

  /**
   * The style variant of the banner.
   */
  @property({ reflect: true }) variant: 'info' | 'danger' | 'success' | 'warning' = 'info'

  render() {
    const icon = iconMap[this.variant] || iconMap.info

    return html`
      <div class="n-banner" role="alert">
        <nord-stack align-items="start" direction="horizontal">
          <nord-icon name=${icon} size="m"></nord-icon>
          <div class="n-banner-content">
            <slot></slot>
          </div>
        </nord-stack>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-banner': Banner
  }
}
